

























































import { Component, Vue } from 'vue-property-decorator';
import AddMemberModal from '@/components/member/memberList/AddMemberModal.vue';
import LeaveMemberModal from '@/components/member/memberList/LeaveMemberModal.vue';
import AccountListCard from '@/components/member/memberList/AccountListCard.vue';
import AccountListTable from '@/components/member/memberList/AccountListTable.vue';
import CommonButton from '@/components/common/CommonButton.vue';
import { vxm } from '@/store';
import { ProjectMemberRating, ProjectMemberResponse } from '@/@types/ProjectMember';


@Component({
  components: {
    AddMemberModal,
    LeaveMemberModal,
    AccountListCard,
    AccountListTable,
    CommonButton,
  },
})
export default class MemberListBase extends Vue {
  private currentDisplayType: 'account-list-card' | 'account-list-table' = 'account-list-card';
  private isOpenAddMemberModal: boolean = false;
  private isOpenLeaveMemberModal: boolean = false;
  private currentProjectName = 'セオリー開発';
  private selectedProjectMemberId = 0;
  private selectedProjectMemberName = '';
  private editMode = false;
  private searchKeyword = '';
  private projectMembers: ProjectMemberResponse[] = [];

  private async mounted() {
    const currentProjectId = 1; // TODO: currentProjectIdが取れるようになったら修正
    await vxm.theoryApi.projectMembersStore.fetchProjectMembersById(currentProjectId);
    this.projectMembers = vxm.theoryApi.projectMembersStore.getHomeProjectMembers?.results ?? [];
  }

  private openAddMemberModal() {
    this.isOpenAddMemberModal = true;
  }

  private closeAddMemberModal() {
    this.isOpenAddMemberModal = false;
  }

  private inviteProjectMember(inviteDate: { email: string; message: string}) {
    // TODO: メンバー招待処理
    console.log(inviteDate);
    this.isOpenAddMemberModal = false;
  }

  private openLeaveMemberModal(memberInfo: { projectMemberId: number; accountName: string }) {
    this.selectedProjectMemberId = memberInfo.projectMemberId;
    this.selectedProjectMemberName = memberInfo.accountName;
    this.isOpenLeaveMemberModal = true;
  }

  private closeLeaveMemberModal() {
    this.isOpenLeaveMemberModal = false;
  }

  private sendProjectMemberRating(memberRating: ProjectMemberRating) {
    console.log({
      projectMemberId: this.selectedProjectMemberId,
      accountName: this.selectedProjectMemberName,
      ...memberRating,
    })// TODO: メンバー評価処理
    this.isOpenLeaveMemberModal = false;
  }

  private changeDisplayType(type: 'account-list-card' | 'account-list-table') {
    this.editMode = false; // 表示形式が変わった時、編集モードを止めて状態の整合性を保ちやすくする。編集モードなのに編集モードになっていないという状況を無くす。
    this.currentDisplayType = type;
  }

  private changeIconColor(displayType: 'account-list-card' | 'account-list-table') {
      return this.currentDisplayType === displayType ? '#4384f3' : 'grey lighten-1';
  }

  private get searchProjectMembers() {
    if (this.searchKeyword.length) {
      return this.projectMembers.filter((member) => {
        return member.accountName.includes(this.searchKeyword);
      })
    } else {
      return this.projectMembers;
    }
  }
}
